import { AppManager } from 'core/appManager';
import { getWhitelabelConfig } from 'core/whitelabel';
import { ProjectConnManager } from 'apps/project/connManager';
import { IssueConnManager } from 'apps/issueTracker/appManager';
import { StoryConnManager } from 'apps/story/main/appManager';
import {
  FeaturedProjectsQuery,
  FeaturedStoriesQuery,
} from 'apps/home/featured/gql';

import i18next from 'i18next';
import { action } from 'mobx';
import { ViralIssuesQuery } from 'apps/microSite/gql';

export class ViralResponseLandingManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.whitelabelConfig = getWhitelabelConfig();
    this.pageConfig = this.whitelabelConfig.pages.home; // [this.route.name];
    this.projectsConn = new ProjectConnManager(this, {
      contains: ['featured_in', 'vr_featured_home'],
      sortBy: 'discover_recent',
      sortOptions: [
        ['discover_recent', i18next.t('Recent')],
        ['followers', i18next.t('Followers')],
        ['contributions', i18next.t('Contributions')],
      ],
      initialBatchSize: 6,
      loadMoreQuery: FeaturedProjectsQuery,
    });
    this.issuesConn = new IssueConnManager(this, {
      contains: ['featured_in', 'vr_featured_home'],
      sortBy: 'recent',
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['comments', i18next.t('Comments')],
      ],
      loadMoreQuery: ViralIssuesQuery,
    });
    this.storiesConn = new StoryConnManager(this, {
      contains: ['featured_in', 'vr_featured_home'],
      sortBy: 'recent',
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['-likes', i18next.t('Likes')],
      ],
      initialBatchSize: 2,
      loadMoreQuery: FeaturedStoriesQuery,
    });
    this.ViralResponseLandingPageQuery();
  }

  @action ViralResponseLandingPageQuery = () => {
    this.projectsConn.loadMore();
    this.issuesConn.loadMore();
    this.storiesConn.loadMore();
  };
}
